import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AutocompleteService {
    filterItems(items: string[], term: string, limit = 10): string[] {
        if (!term) return items.slice(0, limit);
        return items
            .filter(v => this._normalize(v).includes(this._normalize(term)))
            .slice(0, limit);
    }

    private _normalize(text: string): string {
        return text?.normalize('NFD').replace(/[^a-zA-Z0-9\s]/g, '').toLowerCase() ?? '';
    }
}
